import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { LocalStorageService } from '../localstorage/localStorage.service';
import { ApiService } from '../service/api.service';
import { map, catchError } from 'rxjs/operators';
import { MPv2UserLocationLocalStorageKey } from '../../model/key/location.storage';

@Injectable({ providedIn: 'root' })
export class UserLocationService {
  public landingPage: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private localStorageService: LocalStorageService, private apiService: ApiService) { }

  getUserLocationFromIpAddress() {
    return this.apiService.getUserLocationFromIp()
      .pipe(
        map((response: any) => {
          let userLocationDetails = {
            latitude: response.latitude,
            longitude: response.longitude,
            placeName: response.placeName,
            countryCode: response.countryCode,
            date: new Date()
          }
          this.localStorageService.set(MPv2UserLocationLocalStorageKey.UserLocation, userLocationDetails);
          return userLocationDetails;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  getLocationNameInCustomFormat(locationKeyword: string): string {
    let locationName = '';
    if (locationKeyword?.length > 0) {
      let placeName = locationKeyword.toLowerCase();
      if (placeName.includes('usa') || placeName.includes('canada')) {
        let placeAddressList = locationKeyword.split(',');
        for (let index = 0; index < placeAddressList.length - 1; index++) {
          if (index == 0) {
            locationName = placeAddressList[index];
          }
          else {
            locationName += ', ' + placeAddressList[index];
          }
        }
      }
      else {
        let placeAddressList = locationKeyword.split(',');
        if (placeAddressList.length > 2) {

          locationName = placeAddressList[0] + ', ' + placeAddressList[placeAddressList.length - 1];
        }
        else {
          locationName = locationKeyword;
        }
      }
      locationName = locationName.replace(/1|2|3|4|5|6|7|8|9|0/gi, '');
    }
    return locationName.trim();
  }
}
